import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';

/**
 * 操作列：单个「复制」入口，悬停时在下方展开复制目标选项。
 */
export default function TiktokOpsCopyHoverMenu({
  disabled = false,
  busy = false,
  busyLabel = '复制中…',
  triggerLabel = fixedUi("复制"),
  options = [],
}) {
  if (!options.length) return null;

  const blocked = disabled || busy;

  return (
    <div
      className={[
        'tko-copy-hover',
        blocked ? 'tko-copy-hover--blocked' : '',
      ].filter(Boolean).join(' ')}
    >
      <button
        type="button"
        className="wf-tasks-actions__link tko-copy-hover__trigger"
        disabled={blocked}
        aria-haspopup="menu"
      >
        {busy ? busyLabel : triggerLabel}
      </button>
      <div className="tko-copy-hover__menu" role="menu">
        {options.map((opt) => (
          <button
            key={opt.key || opt.label}
            type="button"
            role="menuitem"
            className="tko-copy-hover__item wf-tasks-actions__link"
            disabled={blocked}
            onClick={(e) => {
              e.stopPropagation();
              if (blocked) return;
              opt.onClick?.();
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
